import { ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivateFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { GeneralLedgerExportComponent } from '../modules/public-modules';
import { concatMap, first, map } from 'rxjs/operators';

export const canDeactivateGLGuard: CanDeactivateFn<GeneralLedgerExportComponent> = (
  c: GeneralLedgerExportComponent,
  route: ActivatedRouteSnapshot,
  currentState?: RouterStateSnapshot,
  nextState?: RouterStateSnapshot
): Observable<boolean> | boolean => {
  // task #25894. when updating a GL setup, pop nav confirmation modal if unsaved changes exist
  if (!c.exportSettingsTab?.exportFilesPrimary) {
    return of(true);
  } else {
    return c.exportSettingsTab.exportFilesPrimary.onDeactivate().pipe(
      concatMap(deactivate => {
        if (deactivate) {
          return of(true);
        } else {
          const msg =
            'Are you sure you want to leave this page? Changes you made will not be saved.';
          c.modalService.showConfirmModal(msg, 'Cancel', 'Leave Page', 'Unsaved Changes');
          return c.modalService.confirmModalCallback.pipe(first()).pipe(
            map((confirm: boolean) => {
              if (confirm) {
                return true;
              } else {
                return false;
              }
            })
          );
        }
      })
    );
  }
};
